import { FiPlusCircle } from "react-icons/fi"
import noFarmer from "../../assets/no-famer.png"
import { IoSearchOutline } from "react-icons/io5"

const RenderNoFarmer = ({ handleNewGroup, isSearch = false }) => {
  return (
    <div className="h-[70vh] w-full flex items-center justify-center">
      <div className="text-center flex flex-col items-center justify-center">
        {isSearch ? <div className="h-10 w-10 bg-gray-300 rounded-full flex flex-row items-center justify-center">
          <IoSearchOutline size={24} className="text-black" />
        </div> : <div className="flex items-center justify-center">
          <img src={noFarmer} alt="no farmer" />
        </div>}
        <div className="gap-3 my-4">
          <h1 className="font-semibold text-lg dark:text-white">
            {isSearch ? "No search results" : "There are no farmer info"}
          </h1>
          <p className="text-sm text-black dark:text-white font-normal w-2/3 mx-auto">
            {isSearch ? "Your search did not match any farmer data. Kindly try again" : "You have not added any farmer yet. All farmer details will appear here when you do."}
          </p>
        </div>

        {!isSearch && <button
          onClick={handleNewGroup}
          className="bg-yellowcolor hover:bg-yellowcolor/80 text-black px-6 flex flex-row items-center gap-2 py-2 rounded-md capitalize"
        >
          <FiPlusCircle size={20} />
          Add new farmer
        </button>}
      </div>
    </div>
  )
}

export default RenderNoFarmer
